import moment from 'moment';

const formatDateHourly = (timeStamp: number) => moment.utc(timeStamp).startOf('hour').format();

/* eslint-disable import/no-default-export */
export default formatDateHourly;
